import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: Number }

  connect() {
    var _this = this

    // Add an event listener to cleanup empty campaigns.
    var cleanedCampaignUp = false
    document.addEventListener("turbo:click", function() {
      if (cleanedCampaignUp == false) {
        _this.cleanupEmptyCampaign()

        cleanedCampaignUp = true
      }
    })
  }

  cleanupEmptyCampaign() {
    console.info("Requesting campaign cleanup if appropriate")

    fetch(`/campaigns/${this.idValue}/cleanup`, {
      credentials: "same-origin",
      method: "POST",
      headers: {
        "X-CSRF-Token": $("meta[name='csrf-token']").attr("content"),
      },
    })
  }
}
